<script>
  /*!
    Copyright (c) 2021 - present, Biwabits. 
    https://www.biwabits.com/
*/


  import TextType from './TextType.vue'
  import LanguageModel from '../../models/LanguageModel'
  import { QuestionType } from '../../models/QuestionModel'
  
  export default {
    extends: TextType,
    name: QuestionType.Phone,
    data() {
      return {
        inputType: 'tel', 
        //canReceiveFocus: true,
        allowedChars: '+-0123456789.'

      }
    }
  }
</script>